export default __webpack_public_path__ + "static/media/adn.cf0937ad.svg";